<template>
  <div>
    <Header />
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'

export default {
  components: {
    Header: Header
  }
}
</script>
